import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import CreateEntityMessage from "../Commons/CreateEntityMessage";
import CompanyBalance from "../Balance/CompanyBalance";

class MyPortfolioEntity extends Component {
    render() {
        let options = [];
        this.props.companies.data.results.map((item, index) =>
            options.push({
                value: item.id,
                label: item.title,
            })
        );

        const {currentAdmin, showBalancePopup, selectedCompany} = this.props;

        return (
            selectedCompany
            ?
            <ul className="tab-content profile-info items-list tab-content1 active">
    
                <div style={{padding: '10px 30px 0 30px', position:'relative', zIndex: 5}}>
                    <Select
                        name="form-field-name"
                        noResultsText="Список пуст"
                        value={selectedCompany && selectedCompany.id}
                        onChange={(company) => this.props.handleCompany(company)}
                        clearable={false}
                        options={options}
                    />
                </div>
                
                <CompanyBalance
                    currentAdmin={currentAdmin}
                    selectedCompany={selectedCompany}
                    showBalancePopup={(company) => showBalancePopup(company)}
                    />
                
            </ul>
            :
            <CreateEntityMessage id={this.props.currentUser.id} />
        )
    }
}

export default MyPortfolioEntity;


// WEBPACK FOOTER //
// ./src/components/Profile/SubMyPortfolio/MyPortfolioEntity.js